import apiClient from 'api/base';
import { TaskGroup } from 'models/task-groups.model';

export const getAllGroupsWithTasks = async (): Promise<TaskGroup[]> => {
  const { data } = await apiClient.get('/taskGroupsWithTasks');

  return data;
};

export const getAllTaskGroups = async (): Promise<TaskGroup[]> => {
  const { data } = await apiClient.get('/taskGroups');

  return data;
};

export const createTaskGroup = async (
  taskGroup: Omit<TaskGroup, 'id' | 'createdAt' | 'updatedAt'>,
): Promise<TaskGroup> => {
  try {
    const { data } = await apiClient.post('/taskGroups', { ...taskGroup });

    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const updateTaskGroup = async (
  id: string,
  taskGroup: TaskGroup,
): Promise<TaskGroup> => {
  const { data } = await apiClient.put(`/taskGroups/${id}`, taskGroup);

  return data;
};

export const deleteTaskGroup = async (id: string): Promise<TaskGroup> => {
  const { data } = await apiClient.delete(`/taskGroups/${id}`);

  return data;
};
